import api from "./http-common";

const token = JSON.parse(localStorage.getItem("token"));

const getCPdutyInfo = (data) => {
  return api.post("api/Route/GetCPdutyInfo", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getControlPointDutyList = () => {
  return api.get("api/Route/GetControlPointDutyList", {
    headers: { Authorization: "Bearer " + token },
  });
};

const insCPdutyAllocation = (data) => {
  return api.post("api/Route/InsCPdutyAllocation", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const upCPdutyAllocation = (data) => {
  return api.post("api/Route/UpCPdutyAllocation", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const cancelCPduty = (data) => {
  return api.post("api/Route/CancelCPduty", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const ControlpointService = {
  getCPdutyInfo,
  getControlPointDutyList,
  insCPdutyAllocation,
  upCPdutyAllocation,
  cancelCPduty,
};

export default ControlpointService;
